const { location } = globalThis;

const $articleContainer = document.querySelector('.case-studies__grid');
const $loadMoreBtn = document.querySelector('.case-studies__load');
let pageNum = Number($loadMoreBtn.dataset.page) + 1;
const pageMax = Number($articleContainer.dataset.max);

let hiddenCards = [];

// Initial adjustment to ensure the grid is divisible by 3
adjustCardCount(pageNum, pageMax);

$loadMoreBtn.addEventListener('click', loadMore);

function loadMore() {
  $loadMoreBtn.classList.add('loading');

  const url = location.pathname;

  fetch(`${url}?page=${pageNum}&view=api`)
    .then((res) => res.text())
    .then((html) => {
      $loadMoreBtn.classList.remove('loading');

      if (pageNum >= pageMax) {
        $loadMoreBtn.remove();
      }

      $articleContainer.insertAdjacentHTML('beforeend', html);

      adjustCardCount(pageNum, pageMax);

      pageNum += 1;
    });
}

function adjustCardCount(num, max) {
  clearDuplicateCards();

  hiddenCards.forEach(($card) => {
    $card.style.display = '';
  });
  hiddenCards = [];

  const $cards = Array.from(
    $articleContainer.querySelectorAll('.case-studies-card')
  );
  const totalCards = $cards.length;
  const excessCount = totalCards % 3;

  // Hide excess cards in grid if not the last page
  if (num < max && excessCount > 0) {
    for (let i = 0; i < excessCount; i++) {
      const $card = $cards.pop();
      $card.style.display = 'none';
      hiddenCards.push($card);
    }
  }

  // Reveal any hidden cards if it's the last page
  if (num === max) {
    hiddenCards.forEach(($card) => {
      $card.style.display = '';
    });
    hiddenCards = [];
  }
}

function clearDuplicateCards() {
  $articleContainer
    .querySelectorAll('.case-studies-card')
    .forEach(($article) => {
      const $cards = document.querySelectorAll(
        `[data-handle="${$article.dataset.handle}"]`
      );

      if ($cards.length > 1) {
        $cards.forEach(($card, index) => {
          if (index !== 0) {
            $card.remove();
          }
        });
      }
    });
}
